import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronDownMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-down-medium"} maskId="square-filled-radius-0-stroke-1-IconChevronDownMedium"><path d="M19.207 9.5L12 16.707L4.79297 9.5L5.5 8.79297L12 15.293L18.5 8.79297L19.207 9.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronDownMedium;
